import React, { useEffect } from 'react';
import { Formik, Form } from 'formik';
import { Button, Card, CardBody } from 'reactstrap';
import { useHistory } from 'react-router';
import InputField from 'components/molecules/input-field';
import PublicHeader from 'components/organisms/public-header';
import PublicPageTemplate from 'components/templates/public-page-template';
import { useAuth } from 'providers/auth-provider';
import loginSchema from './login-schema';
import { login } from 'api/v2/admins';

const LoginPage = () => {
  useEffect(() => () => document.body.classList.remove('bg-default'), []);
  const auth = useAuth();
  const history = useHistory();

  useEffect(() => { if (auth.isAuth) history.push('/app'); }, [auth.isAuth, history]);

  const handleSubmit = async (values, actions) => {
    try {
      const admin = await login(values.email, values.password);
      auth.onLogin({ name: admin.first_name, role: admin.role, id: admin.id });
    } catch (e) {
      actions.setSubmitting(false);
      alert(e.message || 'Login failed');
    }
  };

  return (
    <PublicPageTemplate header={<PublicHeader title="" lead="" />}>
      <Card className="bg-secondary border-0 mb-0">
        <CardBody className="px-lg-5 py-lg-5">
          <Formik initialValues={{ email: '', password: '' }} validationSchema={loginSchema} onSubmit={handleSubmit}>
            {(formikProps) => (
              <Form>
                <InputField type="email" name="email" placeholder="Email" />
                <InputField type="password" name="password" placeholder="Password" />
                <Button block color="success" type="submit" disabled={formikProps.isSubmitting}>Submit</Button>
              </Form>
            )}
          </Formik>
        </CardBody>
      </Card>
    </PublicPageTemplate>
  );
};

export default LoginPage;
